export default {"src":"/_next/static/media/amenagement-paysager.8af1b9a4.svg","height":64,"width":66,"blurWidth":0,"blurHeight":0};